module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('md-card', [_c('md-card-content', [_c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "60"
    }
  }, [_c('h2', [_vm._v("Hire Model")]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px",
    on: {
      "click": _vm.viewClientpage
    }
  }, [_vm._v("View Contract Details")])], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "phone-viewport",
    attrs: {
      "id": "vehicleBooking"
    }
  }, [_c('md-list', [_c('md-list-item', {
    staticClass: "md-button-color-toggle",
    class: {
      'md-active': _vm.isActiveVehicleBooking
    },
    attrs: {
      "id": "showvehicleBooking"
    }
  }, [_c('span', [_vm._v("Vehicle Booking")]), _vm._v(" "), _c('md-list-expand', [_c('md-list', [_c('md-layout', {
    staticClass: "mrgtop-2per",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("No.Of Trucks")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "noOfTrucks",
      "name": "noOfTrucks",
      "disabled": ""
    },
    model: {
      value: (_vm.Vbooking.noOfTrucks),
      callback: function($$v) {
        _vm.$set(_vm.Vbooking, "noOfTrucks", $$v)
      },
      expression: "Vbooking.noOfTrucks"
    }
  })], 1), _vm._v(" "), (!_vm.Vbooking.noOfTrucks) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.noOfTrucksError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px",
    staticStyle: {
      "margin-top": "18px"
    },
    on: {
      "click": function($event) {
        _vm.openAddTruckDialog('dialog1')
      }
    }
  }, [_vm._v("Select Truck")]), _vm._v(" "), _c('h3', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.Vbooking.noOfTrucks != _vm.checkItems.length ? _vm.error.vehicleSelectError1 : ''))])], 1)], 1), _vm._v(" "), (this.checkItems.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Vehicle Booking Details")])]), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "hireModel2"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Vehicle Number")]), _vm._v(" "), _c('th', [_vm._v("Vehicle Type")]), _vm._v(" "), _c('th', [_vm._v("Driver Name")]), _vm._v(" "), _c('th', [_vm._v("Driver Number")]), _vm._v(" "), _c('th', [_vm._v("Action")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.checkItems), function(obj, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _vm._l((obj), function(item, index) {
      return (index != 'isTruckMasterActive' && index != 'vehicleTruckId') ? _c('td', {
        key: index
      }, [_vm._v(_vm._s(item))]) : _vm._e()
    }), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.removeSelectedTruck(obj.vehicleTruckId, index, obj)
        }
      }
    }, [_c('md-icon', [_vm._v("delete_sweep")])], 1)], 1)], 2)
  }))])])]) : _vm._e(), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px",
    attrs: {
      "id": "addButtonLoader"
    },
    on: {
      "click": function($event) {
        _vm.addVehicleBooking()
      }
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "phone-viewport",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "followup"
    }
  }, [_c('md-list', [_c('md-list-item', {
    staticClass: "md-button-color-toggle",
    class: {
      'md-active': _vm.isActiveFollowActivities
    },
    attrs: {
      "id": "showvehicleBooking"
    }
  }, [_c('span', [_vm._v("FollowUp")]), _vm._v(" "), _c('md-list-expand', [_c('md-list', [_c('md-layout', {
    staticClass: "mrgtop-2per",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Contract Series")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.contractDetailModal.contractSeries),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "contractSeries", $$v)
      },
      expression: "contractDetailModal.contractSeries"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Contract Type")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.contractDetailModal.contractType),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "contractType", $$v)
      },
      expression: "contractDetailModal.contractType"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Monthly Charges")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.contractDetailModal.monthlyRent),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "monthlyRent", $$v)
      },
      expression: "contractDetailModal.monthlyRent"
    }
  })], 1)], 1)], 1), _vm._v(" "), (_vm.contractDetailModal.contractType != 'fuelType') ? _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Allowed Km")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.contractDetailModal.allowedKm),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "allowedKm", $$v)
      },
      expression: "contractDetailModal.allowedKm"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Over Charges")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.contractDetailModal.overcharges),
      callback: function($$v) {
        _vm.$set(_vm.contractDetailModal, "overcharges", $$v)
      },
      expression: "contractDetailModal.overcharges"
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr-border"
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px",
    on: {
      "click": function($event) {
        _vm.openSelectTruckDialog('dialog2')
      }
    }
  }, [_vm._v("New Assignment")])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), (_vm.showFollowUpActivity.length > 0) ? _c('h3', [_vm._v("FollowUp Details")]) : _vm._e(), _vm._v(" "), (_vm.showFollowUpActivity.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  })]), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "hireModel1"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr.no")]), _vm._v(" "), _c('th', [_vm._v("Truck No")]), _vm._v(" "), _c('th', [_vm._v("From Location")]), _vm._v(" "), _c('th', [_vm._v("To Location")]), _vm._v(" "), _c('th', [_vm._v("Km Covered")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.showFollowUpActivity), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.regdNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.fromLocation))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.toLocation))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.kmCovered))])])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.showFollowUpActivity.length > 0) ? _c('md-layout', {
    staticClass: "mrgtop-2per",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "dialog1",
    staticClass: "HereDialog",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom"
    }
  }, [_c('md-dialog-title', [_c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.error.vehicleSelectError.length > 0 ? _vm.error.vehicleSelectError : ""))])]), _vm._v(" "), _c('md-dialog-content', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Vehicle Booking Details")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "hireModel3"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Action")]), _vm._v(" "), _c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Vehicle Number")]), _vm._v(" "), _c('th', [_vm._v("Vehicle Type")]), _vm._v(" "), _c('th', [_vm._v("Driver Name")]), _vm._v(" "), _c('th', [_vm._v("Driver Number")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.unCheckItems), function(obj, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('md-checkbox', {
      staticClass: "md-primary",
      attrs: {
        "md-value": obj.vehicleTruckId,
        "name": 'vehicle' + (index + 1),
        "id": 'vehicle' + (index + 1)
      },
      on: {
        "change": function($event) {
          _vm.checkSelectVehicle(index, obj)
        }
      },
      model: {
        value: (_vm.emptyArray[index]),
        callback: function($$v) {
          _vm.$set(_vm.emptyArray, index, $$v)
        },
        expression: "emptyArray[index]"
      }
    })], 1), _vm._v(" "), _c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _vm._l((obj), function(item, index) {
      return (index != 'isTruckMasterActive' && index != 'vehicleTruckId') ? _c('td', {
        key: index
      }, [_vm._v(_vm._s(item))]) : _vm._e()
    })], 2)
  }))])])])]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    attrs: {
      "disabled": _vm.checkIsDisabled
    },
    on: {
      "click": _vm.onSubmitTable
    }
  }, [_vm._v("Ok")])], 1)], 1), _vm._v(" "), _c('md-dialog', {
    ref: "dialog2",
    staticClass: "HereDialog",
    attrs: {
      "md-open-from": "#custom",
      "md-close-to": "#custom"
    }
  }, [_c('md-dialog-content', [_c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('md-layout', {
    staticClass: "modal-header-set",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "55"
    }
  }, [_c('h2', {
    staticStyle: {
      "margin": "7px"
    }
  }, [_vm._v("Follow Up")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }, [_c('md-button', {
    staticClass: "md-icon-button md-raised md-dense modal-close-btnn",
    on: {
      "click": function($event) {
        _vm.closeModal()
      }
    }
  }, [_c('md-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  })], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "Date"
    },
    model: {
      value: (_vm.followModal.Date),
      callback: function($$v) {
        _vm.$set(_vm.followModal, "Date", $$v)
      },
      expression: "followModal.Date"
    }
  }), _vm._v(" "), (!_vm.followModal.Date) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.DateError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-2per",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Select Truck")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.showVehicleId,
      "option-value": "vehicleTruckId",
      "option-text": "regdNo",
      "placeholder": "Select Vehicle "
    },
    model: {
      value: (_vm.followModal.selectTruck),
      callback: function($$v) {
        _vm.$set(_vm.followModal, "selectTruck", $$v)
      },
      expression: "followModal.selectTruck"
    }
  })], 1), _vm._v(" "), (!_vm.followModal.selectTruck) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.selectTruckError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("From Location")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.locationMasterList,
      "option-value": "pickupLocation",
      "option-text": "pickupLocation",
      "placeholder": "Select Location "
    },
    model: {
      value: (_vm.followModal.fromLocation),
      callback: function($$v) {
        _vm.$set(_vm.followModal, "fromLocation", $$v)
      },
      expression: "followModal.fromLocation"
    }
  })], 1), _vm._v(" "), (!_vm.followModal.fromLocation) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.fromLocationError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("From Location")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.locationMasterList,
      "option-value": "pickupLocation",
      "option-text": "pickupLocation",
      "placeholder": "Select Location "
    },
    model: {
      value: (_vm.followModal.toLocation),
      callback: function($$v) {
        _vm.$set(_vm.followModal, "toLocation", $$v)
      },
      expression: "followModal.toLocation"
    }
  })], 1), _vm._v(" "), (!_vm.followModal.toLocation) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.toLocationError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Container No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "containerNo",
      "name": "containerNo"
    },
    model: {
      value: (_vm.followModal.containerNo),
      callback: function($$v) {
        _vm.$set(_vm.followModal, "containerNo", $$v)
      },
      expression: "followModal.containerNo"
    }
  })], 1), _vm._v(" "), (!_vm.followModal.containerNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.containerNoError))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("GRN No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "grnNo",
      "name": "grnNo"
    },
    model: {
      value: (_vm.followModal.grnNo),
      callback: function($$v) {
        _vm.$set(_vm.followModal, "grnNo", $$v)
      },
      expression: "followModal.grnNo"
    }
  })], 1), _vm._v(" "), (!_vm.followModal.grnNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.grnNoError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipper Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "shipperName",
      "name": "shipperName"
    },
    model: {
      value: (_vm.followModal.shipperName),
      callback: function($$v) {
        _vm.$set(_vm.followModal, "shipperName", $$v)
      },
      expression: "followModal.shipperName"
    }
  })], 1), _vm._v(" "), (!_vm.followModal.shipperName) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.shipperNameError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("O.M.R.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "omr",
      "name": "omr"
    },
    model: {
      value: (_vm.followModal.omr),
      callback: function($$v) {
        _vm.$set(_vm.followModal, "omr", $$v)
      },
      expression: "followModal.omr"
    }
  })], 1), _vm._v(" "), (!_vm.followModal.omr) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.omrError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "10"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("I.M.R.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "imr",
      "name": "imr"
    },
    model: {
      value: (_vm.followModal.imr),
      callback: function($$v) {
        _vm.$set(_vm.followModal, "imr", $$v)
      },
      expression: "followModal.imr"
    }
  })], 1), _vm._v(" "), (!_vm.followModal.imr) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.imrError))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "15"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Kilometer Covered")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "number",
      "min": "0",
      "id": "kmCovered",
      "name": "kmCovered"
    },
    on: {
      "keyup": function($event) {
        _vm.finalAmount()
      }
    },
    model: {
      value: (_vm.followModal.kmCovered),
      callback: function($$v) {
        _vm.$set(_vm.followModal, "kmCovered", $$v)
      },
      expression: "followModal.kmCovered"
    }
  })], 1), _vm._v(" "), (!_vm.followModal.kmCovered) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.kmCoveredError))]) : _vm._e()], 1)], 1)], 1)])]), _vm._v(" "), _c('md-dialog-actions', [_c('md-button', {
    staticClass: "md-primary",
    on: {
      "click": _vm.addHireFollow
    }
  }, [_vm._v("Ok")])], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop1",
    staticStyle: {
      "z-index": "9999999999"
    },
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    },
    on: {
      "close": _vm.onClose
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-357cf786","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/view/vehicleQuotation/hireModel.vue
// module id = 2516
// module chunks = 0